import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CustomerDeactivatedService } from '../../servicios/customer-deactivate.service';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../../../../../../core/decorators/auto-unsubscribe';

@Component({
    selector: 'app-desactivar-customer-modal',
    templateUrl: './desactivar-customer-modal.component.html',
    styleUrls: ['./desactivar-customer-modal.component.scss']
})

@AutoUnsubscribe()
export class DesactivarCustomerModalComponent implements OnInit {
    @Output() modalClose = new EventEmitter<any>();
    error: string;
    code: string;

    @Input() title: string;
    @Input() message: string;
    @Input() textButtonOk: string;
    @Input() textButtonCancel: string;

    @Input() aspa: boolean;
    @Input() isButtonOk: boolean;
    @Input() isButtonCancel: boolean;

    @Input() dataCustomer: any;
    deactivarSubscription: Subscription;

    constructor(
        private _customerDeactivatedService: CustomerDeactivatedService,
        private translateService: TranslateService,
        private toastr: ToastrService, ) { }

    ngOnInit() { }


    closeModal(datos: boolean) {

        if (datos) {
            const parametros_In = {
                customerID: this.dataCustomer.CustomerId
            };

            this.deactivarSubscription = this._customerDeactivatedService.post<any>(JSON.stringify(parametros_In))
                .subscribe(data => {
                    const auxdata = data.Response;

                    if (auxdata) {
                        if (auxdata.Data) {
                            this.translateService.get('genericos.toastr.successfulDesactivar').subscribe(text => {
                                this.toastr.success(text);
                                this.modalClose.emit(auxdata.Data);
                            });
                        } else {
                            this.translateService.get('genericos.toastr.errorDesactivar').subscribe(res => {
                                this.toastr.error(res);
                            });
                            this.modalClose.emit('cerrar');
                        }

                    } else {
                        this.error = data.Warning.Content;
                        this.code = data.Warning.Title;
                        this.translateService.get('genericos.toastr.errorDesactivar').subscribe(res => {
                            this.toastr.error(res);
                        });
                        this.modalClose.emit('cerrar');
                    }
                });

        } else {
            this.modalClose.emit('cerrar');
        }
    }
}
